export default "__VITE_ASSET__BwIsOwnQ__"